// DiscoverPage.js
// Page for discovering new types of tasks to run

import React, { useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import BottomNav from '../components/BottomNav';
import AddTodoForm from '../components/AddTodoForm';

const TASK_TEMPLATES = [
  {
    id: 'meal-planning',
    title: 'Meal Planning',
    description: 'Plan weekly meals, create grocery lists, and find recipes',
    icon: '🍽️'
  },
  {
    id: 'processing-return',
    title: 'Processing Return',
    description: 'Handle product returns, print labels, and track refunds',
    icon: '📦'
  },
  {
    id: 'planning-dates',
    title: 'Planning Dates',
    description: 'Find restaurants, activities, and plan special outings',
    icon: '💑'
  },
  {
    id: 'picking-gifts',
    title: 'Picking Gifts',
    description: 'Find the perfect gift for birthdays, holidays, or special occasions',
    icon: '🎁'
  },
  {
    id: 'scheduling-home-care',
    title: 'Scheduling Home Care',
    description: 'Book cleaning, repairs, lawn care, and other home services',
    icon: '🏡'
  },
  {
    id: 'researching-flights',
    title: 'Researching Flights',
    description: 'Find the best flight deals and travel options',
    icon: '✈️'
  }
];

function DiscoverPage({ user, userProfile }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [familyData, setFamilyData] = useState(null);

  const handleCardClick = async (template) => {
    // Fetch family data if not already loaded
    if (!familyData && userProfile?.familyId) {
      const familyDoc = await getDoc(doc(db, 'families', userProfile.familyId));
      if (familyDoc.exists()) {
        setFamilyData(familyDoc.data());
      }
    }

    setSelectedTemplate(template);
    setShowAddForm(true);
  };

  const handleCloseForm = () => {
    setShowAddForm(false);
    setSelectedTemplate(null);
  };

  return (
    <div className="discover-page">
      <div className="discover-header">
        <h1>Discover</h1>
        <p>Find new ways to get help with your tasks</p>
      </div>

      <div className="discover-grid">
        {TASK_TEMPLATES.map((template) => (
          <button
            key={template.id}
            className="discover-card"
            onClick={() => handleCardClick(template)}
          >
            <span className="discover-card-icon">{template.icon}</span>
            <h3 className="discover-card-title">{template.title}</h3>
            <p className="discover-card-description">{template.description}</p>
          </button>
        ))}
      </div>

      <BottomNav user={user} userProfile={userProfile} />

      {showAddForm && (
        <AddTodoForm
          onClose={handleCloseForm}
          familyId={userProfile.familyId}
          familyData={familyData}
          currentUserId={user.uid}
          userEmail={user.email}
          prefillTitle={selectedTemplate?.title}
        />
      )}
    </div>
  );
}

export default DiscoverPage;
